import React, { useState } from "react";
import { Box, Grid } from "@material-ui/core";
import useStyles from "./styles";
import { useHistory } from "react-router-dom";
import { dashboardOptions } from "./empDashboardOptions";
import { Skeleton } from "@material-ui/lab";

const Card = ({ headline, link, image, color = "#ffffff" }) => {
  return (
    <div
      className="emp-navigation-card-container"
      style={{ backgroundColor: color }}
    >
      <div className="emp-navigation-card-title">
        {image ? (
          <img src={image} width="100%" height="100%" alt="image_logo" />
        ) : (
          <Skeleton variant="rect" width="100%" height="100%" />
        )}
      </div>
      <div className="emp-navigation-card-sub-container">
        <div className="emp-navigation-card-content">
          <span className="emp-dash-dot"></span>
          <h2 className="emp-navigation-card-headline">
            {image ? (
              headline
            ) : (
              <Skeleton animation="wave" width={180} height="100%" />
            )}
          </h2>
          {/* <p className="emp-navigation-card-content-text">{content}</p> */}
          {/* <p className="emp-navigation-card-subtext">{subtext}</p> */}
        </div>
      </div>
    </div>
  );
};

const EmployeeDashboardTab = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div>
      <Grid container spacing={2} columns={16}>
        {dashboardOptions.map((item, index) => (
          <Grid
            key={item.id}
            item
            xl={3}
            lg={3}
            md={4}
            sm={6}
            xs={12}
            onClick={() => history.push(item.link)}
          >
            <Card
              headline={item.label}
              link={item.link}
              image={item.image}
              subtext="Something short here"
              color={item.color}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default EmployeeDashboardTab;
